import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type UseGetEventsStatsParams = {
  filters: {
    employee?: string;
    date_range: (string | null)[];
  };
};

type UseGetEventsStatsProps = {
  params: UseGetEventsStatsParams;
  enabled?: boolean;
};

interface EventsStatsResponse {
  events_count: number;
  employees_count: number;
}

const fetchDashboardEventsStats = async ({ params }: UseGetEventsStatsProps) => {
  const response = await CustomAxios.get<EventsStatsResponse>(`dashboard/events-stats`, { params });
  const { data } = response;
  return data;
};

export function useGetDashboardEventsStats({ params, enabled = true }: UseGetEventsStatsProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.dashboardEvents, params],
    queryFn: () => fetchDashboardEventsStats({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
